<template>
  <div
    class="customer-form"
    :class="{ 'no-address-widget': (!address) }"
  >
    <v-subheader>
      {{ title }}
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            icon
            medium
            @click.stop="clearCustomerForm()"
            class="mr-2 clear-btn"
            color="gray darken-2"
          >
            <v-icon medium>mdi-broom</v-icon>
          </v-btn>
        </template>
        <span>{{ lang.customers.widget.resetCustomerForm }}</span>
      </v-tooltip>
    </v-subheader>
    <v-row class="spread">
      <v-col cols="11">
        <v-form
          ref="newCustomerForm"
          v-model="valid"
          lazy-validation
        >
          <v-row class="customer-form-row spread">
            <v-col cols="12" lg="4" md="12" sm="12" xs="12" class="customer-form-col">
              <v-text-field
                :label="lang.orders.new.customer.phone"
                v-model="customer.phone"
                :rules="lang.customers.edit.rules.phoneRules"
                v-mask="phone_mask"
                :disabled="searchLoading"
                type="text"
                ref="phone"
                autocomplete="new-password"
                filled
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="4" md="12" sm="12" xs="12" class="customer-form-col">
              <v-text-field
                :label="lang.customers.datatable.headers.identity"
                v-model="customer.identity"
                :rules="lang.customers.edit.rules.cpfRules"
                v-mask="cpf_mask"
                :disabled="searchLoading"
                autocomplete="new-password"
                filled
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="4" md="12" sm="12" xs="12" class="customer-form-col">
              <v-menu
                v-model="date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="190px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-bind="attrs"
                    v-on="on"
                    :value="formatDateAlt(customer.birth_date, false)"
                    :label="lang.customers.datatable.headers.birth_date"
                    readonly
                    filled
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="customer.birth_date"
                  locale="pt-br"
                  no-title
                  @input="date_menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="customer-form-row spread">
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="customer-form-col">
              <v-text-field
                :label="lang.customers.widget.nameOrId"
                v-model="customer.name"
                :rules="lang.customers.edit.rules.nameRules"
                :disabled="searchLoading"
                autocomplete="new-password"
                filled
              ></v-text-field>
            </v-col>
          </v-row>
          <transition
            name="wideClose"
            mode="out-in"
            :duration="555"
          >
            <div v-if="showAddress">
              <v-row class="customer-form-row spread">
                <v-col cols="5" lg="3" md="5" sm="5" xs="5" class="customer-form-col">
                  <v-text-field
                    :label="lang.orders.new.customer.cep"
                    v-model="customer.address.cep"
                    :rules="lang.customers.edit.rules.cepRules"
                    v-mask="cep_mask"
                    :loading="editingLoading"
                    :disabled="(editingLoading || searchLoading)"
                    autocomplete="new-password"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="7" lg="6" md="7" sm="7" xs="7" class="customer-form-col">
                  <v-text-field
                    :label="lang.orders.new.customer.address"
                    v-model="customer.address.address"
                    :rules="lang.customers.edit.rules.addressRules"
                    :loading="editingLoading"
                    :disabled="(editingLoading || searchLoading)"
                    autocomplete="new-password"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="5" lg="3" md="5" sm="5" xs="5" class="customer-form-col">
                  <v-text-field
                    :label="lang.orders.new.customer.address_number"
                    v-model="customer.address.num"
                    :rules="lang.customers.edit.rules.numRules"
                    :disabled="searchLoading"
                    ref="addressNum0"
                    autocomplete="new-password"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="7" lg="3" md="7" sm="7" xs="7" class="customer-form-col">
                  <v-text-field
                    :label="lang.orders.new.customer.com"
                    v-model="customer.address.comp"
                    :rules="lang.customers.edit.rules.compRules"
                    :disabled="searchLoading"
                    autocomplete="new-password"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="12" lg="3" md="12" sm="12" xs="12" class="customer-form-col">
                  <v-text-field
                    :label="lang.orders.new.customer.neighborhood"
                    v-model="customer.address.neighborhood"
                    :rules="lang.customers.edit.rules.neighborhoodRules"
                    :loading="editingLoading"
                    :disabled="(editingLoading || searchLoading)"
                    autocomplete="new-password"
                    filled
                  ></v-text-field>
                </v-col>
                <v-col cols="6" lg="3" md="6" sm="6" xs="6" class="customer-form-col">
                  <v-select
                    :items="states"
                    v-model="customer.address.state"
                    :label="lang.orders.new.customer.state"
                    :loading="editingLoading"
                    :disabled="(editingLoading || searchLoading)"
                    filled
                  ></v-select>
                </v-col>
                <v-col cols="6" lg="3" md="6" sm="6" xs="6" class="customer-form-col">
                  <v-select
                    :items="cities"
                    v-model="customer.address.city"
                    :label="lang.orders.new.customer.city"
                    :loading="editingLoading"
                    :disabled="(editingLoading || searchLoading)"
                    filled
                  ></v-select>
                </v-col>
              </v-row>
            </div>
          </transition>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-row v-on="on" class="open-address-row spread">
                <v-col
                  @click.stop="switchAddress"
                  cols="12"
                  class="open-address-col green"
                >
                  <v-icon v-if="showAddress">mdi-chevron-double-up</v-icon>
                  <v-icon v-else>mdi-chevron-double-down</v-icon>
                </v-col>
              </v-row>
            </template>
            <span>{{ (showAddress ? lang.customers.widget.hideAddress : lang.customers.widget.showAddress) }}</span>
          </v-tooltip>
        </v-form>
      </v-col>
      <v-col cols="1" class="actions-col">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click.stop="confirmCustomer"
              color="green"
              class="action-btn"
              small
              dark
            >
              <v-icon>mdi-account-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.customers.widget.confirmRegister }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              @click.stop="$emit('manual-search', true)"
              :disabled="switchSearch"
              class="action-btn manual-search-btn"
              :class="{ 'hide-address': !showAddress }"
              color="primary"
              small
              dark
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.customers.widget.searchCustomer }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <div
              v-on="on"
              class="switch-btn"
              :class="{ 'hide-address': !showAddress }"
            >
              <v-switch
                v-model="switchSearch"
                class="switch-search"
                small
                dense
                flat
              ></v-switch>
            </div>
          </template>
          <span>{{ `${(switchSearch ? lang.customers.widget.switchSearch.disableSearch : lang.customers.widget.switchSearch.enableSearch)}` }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import addressesApi from '../../mixins/addresses_api'
import customers from '../../mixins/index'
import widget from '../../mixins/widget'

export default {
  mixins: [ appdata, utils, addressesApi, customers, widget ],
  props: {
    value: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    searchLoading: {
      type: Boolean,
      default: false
    },
    autoSearch: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      customer: Object.assign({}, this.value),
      wtCustomer: {},
      valid: false,
      switchSearch: true,
      showAddress: false,
      index: 0,
      date_menu: false
    }
  },
  computed: {
    address: function () {
      return this.customer.address
    }
  },
  watch: {
    switchSearch: {
      immediate: true,
      handler (newValue) {
        if (newValue !== this.autoSearch) this.$emit('switchedSearch', newValue)
      }
    },
    autoSearch: {
      immediate: true,
      handler (newValue) {
        if (newValue !== this.switchSearch) this.switchSearch = newValue
      }
    },
    customer: {
      deep: true,
      handler (newValue) {
        clearTimeout(this.wtCustomer.timeout)
        this.wtCustomer.timeout = setTimeout(function () {
          this.$emit('update', newValue)
        }.bind(this), 545)
      }
    }
  },
  methods: {
    clearCustomerForm () {
      this.customer = {
        id: 0,
        phone: '',
        name: '',
        identity: '',
        address: {
          cep: '',
          address: '',
          num: '',
          comp: '',
          neighborhood: '',
          state: this.get_options.default_state,
          city: this.get_options.default_city
        }
      }
      this.$refs.newCustomerForm.resetValidation()
    },
    switchAddress () {
      this.showAddress = !this.showAddress
      this.$store.dispatch('setPreferences', { customers_widget_showaddress: this.showAddress })
    },
    confirmCustomer () {
      if (this.$refs.newCustomerForm.validate()) {
        if (typeof this.customer.addresses === 'undefined' && typeof this.customer.address !== 'undefined') {
          this.customer.address = this.validateAddress(this.customer.address)
          this.customer.addresses = (this.customer.address ? [ this.customer.address ] : [])
        }
        this.$emit('confirmCustomer', this.customer)
      }
    },
    validateAddress ({ address, cep, num, comp, neighborhood, city, state }) {
      return (address && cep && num && neighborhood && city && state ? { address, cep, num, comp, neighborhood, city, state } : false)
    }
  },
  mounted () {
    this.customer = Object.assign({}, this.value)
    this.showAddress = this.preferences.customers_widget_showaddress
  }
}
</script>
